// AlertProvider.tsx
import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from "react";
import CustomAlert, {
  type CustomAlertProps,
} from "../components/base/CustomAlert";

interface AlertContextType {
  showAlert: (config: Omit<CustomAlertProps, "visible">) => void;
  hideAlert: () => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [alert, setAlert] = useState<CustomAlertProps | null>(null);
  const [alertKey, setAlertKey] = useState(0);

  const showAlert = (config: Omit<CustomAlertProps, "visible">) => {
    setAlert(config);
    setAlertKey((prev) => prev + 1);
  };

  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {children}
      {alert && (
        <CustomAlert
          key={alertKey}
          title={alert.title}
          text={alert.text}
          icon={alert.icon}
          confirmButtonText={alert.confirmButtonText}
          confirmButtonColor={alert.confirmButtonColor}
          onConfirm={alert.onConfirm}
          showCancelButton={alert.showCancelButton}
          cancelButtonText={alert.cancelButtonText}
          cancelButtonColor={alert.cancelButtonColor}
          onCancel={alert.onCancel}
          onClose={hideAlert}
        />
      )}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert debe usarse dentro de AlertProvider");
  }
  return context;
};
